import {
  buildAllRollupRequest,
  createReportingClient,
  fetchAllPages,
} from "@/apis/clients/reportingClient";
import type { ArrivalReportResponse, ReportScope } from "@/types/reporting";

const ARRIVAL_FIELDS = [
  "avg_dwell_time_min",
  "projected_unique_visits",
  "projected_visits",
] as const;

const ARRIVAL_POI_FIELDS = [
  "avg_dwell_time_min",
  "poi_address",
  "poi_name",
  "projected_unique_visits",
  "projected_visits",
] as const;

// rollup: "all" collapses the date range into one summed row per campaign_id
// grouping, which is what the KPI cards need — no client-side re-sum required.
// Campaigns without Arrival data return an empty results array, not an error.
export const getArrivalReport = (
  params: ReportScope
): Promise<ArrivalReportResponse> =>
  createReportingClient()
    .post("arrival-standard", {
      json: buildAllRollupRequest(ARRIVAL_FIELDS, params),
    })
    .json<ArrivalReportResponse>();

// rollup: "all" with POI dimension fields groups into one summed row per
// (poi_name, poi_address) combination — same mechanic as the performance table.
// fetchAllPages handles campaigns with >10,000 POI locations.
export const getArrivalPoiReport = (
  params: ReportScope
): Promise<ArrivalReportResponse> =>
  fetchAllPages<ArrivalReportResponse>(
    "arrival-standard",
    buildAllRollupRequest(ARRIVAL_POI_FIELDS, params)
  );
